<template>
  <section
    aria-live="polite"
    class="notification-center"
  >

    <h2 class="sr-only">Benachrichtigungen</h2>

    <div class="notification-center__content">
      <transition-group
        class="notification-center__list"
        name="slide"
        tag="ul"
      >
        <li
          v-for="item in $store.state.notifications.list"
          :key="item.id"
          class="notification-center__item"
        >
          <a-notification
            :text="item.text"
            :timeout="item.timeout"
            :type="item.type"
            @remove="$store.commit('notifications/remove', item.id)"
          />
        </li>
      </transition-group>
    </div>

  </section>
</template>

<script>
import ANotification from '@/components/singletons/atoms/ANotification'

export default {
  name: 'SNotificationCenter',

  components: {
    ANotification
  }
}
</script>

<style scoped>
.notification-center {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: var(--z-index-header);
}

@supports (position: sticky) {
  .notification-center {
    position: sticky;
    width: var(--container-width);
    max-width: 100%;
    margin: 0 auto;
    z-index: var(--z-index-notifications);
  }
}

.notification-center__content {
  position: absolute;
  width: 100%;
  padding: 0 var(--container-padding);
}

.notification-center__list {
  list-style: none;

  position: relative;
  margin: 0;
  padding: 0;
}

.notification-center__item {
  position: relative;
  z-index: 1;

  border-bottom: 2px solid #fff;

  transition: transform 0.5s;
}

.notification-center__item:last-child {
  border-bottom: 0;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-100%);
}

.slide-leave-active {
  position: absolute;
  width: 100%;
  z-index: 0;
}
</style>
